import { Component, OnInit, ViewChild } from '@angular/core';
import { FilterHipoModel } from 'src/app/models/hipo/FilterHipoModel';
import { HipoModel } from 'src/app/models/hipo/HipoModel';
import { IFilterHipoModel } from 'src/app/models/interfaces/hipo/IFilterHipoModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ICategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/ICategoriaHipoModel';
import { CategoriaHipoModel } from 'src/app/models/categoria-hipo/CategoriaHipoModel';
import { ITipoReglaModel } from 'src/app/models/interfaces/tipo-regla/ITipoReglaModel';
import { TipoReglaModel } from 'src/app/models/tipo-regla/TipoReglaModel';
import { CategoriaHipoService } from 'src/app/services/categoria-hipo/categoria-hipo.service';
import { TipoReglaService } from 'src/app/services/tipo-regla/tipo-regla.service';
import { IFilterCategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/IFilterCategoriaHipoModel';
import { FilterCategoriaHipoModel } from 'src/app/models/categoria-hipo/FilterCategoriaHipoModel';
import { IFilterTipoReglaModel } from 'src/app/models/interfaces/tipo-regla/IFilterTipoReglaModel';
import { FilterTipoReglaModel } from 'src/app/models/tipo-regla/FilterTipoReglaModel';
import { SedeService } from 'src/app/services/sede/sede.service';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { HipoService } from 'src/app/services/hipo/hipo.service';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { Roles } from 'src/app/models/common/enumModel';
import { IHipoModel } from 'src/app/models/interfaces/hipo/IHipoModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ITipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/ITipoAccidenteModel';
import { TipoAccidenteModel } from 'src/app/models/tipo-accidente/TipoAccidenteModel';
import { TipoAccidenteService } from 'src/app/services/tipo-accidente/tipo-accidente.service';
import { IFilterTipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/IFilterTipoAccidenteModel';
import { FilterTipoAccidenteModel } from 'src/app/models/tipo-accidente/FilterTipoAccidenteModel';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';

@Component({
  templateUrl: './hipos-seguimiento-listar.component.html',
  styleUrls: ['./hipos-seguimiento-listar.component.css']
})
export class HiposSeguimientoListarComponent implements OnInit {
  esAdminSSO:boolean = false;
  listaHipos: HipoModel[] = new Array<HipoModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaCategorias: ICategoriaHipoModel[] = new Array<CategoriaHipoModel>();
  listaTipoRegla: ITipoReglaModel[]=new Array<TipoReglaModel>();
  listaTipoAccidente: ITipoAccidenteModel[]=new Array<TipoAccidenteModel>();
  model: IFilterHipoModel;
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  listaAnios: Number[];
  
  @ViewChild('paginator') paginator!: MatPaginator;
  
  resultsLength = 0;
  currentPage = 0;
  displayedColumns: string[] = ['compania', 'empresa', 'texto', 'gbu', 'sede', 'proyecto', 'categoria', 'tiporegla', 'fechaevento','tiempoperdido', 'tipoempleado', 'seguimiento', 'tipoaccidente', 'acciones'];
  constructor(
    private storage: StorageService,
    private service: HipoService,
    private categoriaService: CategoriaHipoService,
    private tiporeglaService: TipoReglaService,
    private calendarioService: CalendarioSsoService,
    private sedeService: SedeService,
    private tipoAccidenteService: TipoAccidenteService,
    private confirmDialogService: ConfirmDialogService
  ) {
    this.model = new FilterHipoModel();
    this.model.pageSize=30;
    this.listaAnios = new Array<number>();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.model.idCompania = usuario.companiaDefault.idCompania;
    if(usuario.selectedRoles){
      this.esAdminSSO = usuario.selectedRoles.find(p => p === Roles.ADMINISTRADORSSO)? true : false;
    }
   }

  ngOnInit(): void {
    this.companiaChanged();

    const filterCategoria: IFilterCategoriaHipoModel = new FilterCategoriaHipoModel();
    this.categoriaService.getAllList(filterCategoria)
      .subscribe((data) => {
        this.listaCategorias = data;
      });

    const filterTipoRegla: IFilterTipoReglaModel = new FilterTipoReglaModel();
    this.tiporeglaService.getAllList(filterTipoRegla)
      .subscribe((data) => {
        this.listaTipoRegla = data;
      });

      
      const filterTipoAccidente: IFilterTipoAccidenteModel = new FilterTipoAccidenteModel();
      this.tipoAccidenteService.getAllList(filterTipoAccidente)
        .subscribe((data) => {
          this.listaTipoAccidente = data;
        });
        this.calendarioService.getAnios()
        .subscribe((data: number[]) => {
          this.listaAnios = data;
        });
      this.search();
  }

  

  companiaChanged() {

    this.listaSedes = [];
    this.model.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getAllList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    this.model.pageSize = 30;
    this.service
      .getList(this.model)
      .subscribe((data: SearchResultModel<HipoModel[]>) => {
        this.listaHipos = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.service
      .exportList(this.model)
      .subscribe(data => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob:any = data.body;// new Blob([data.body], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        
        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `hipos-${Date.now()}.xlsx`);

      //  this.createImageFromBlob(data);
      //  this.isImageLoading = false;
     }, error => {
      //  this.isImageLoading = false;
      //  console.log(error);
     });
  }

  deleteHipo(element: IHipoModel): void {
    this.confirmDialogService.open('¿Seguro de eliminar el registro HIPO?');
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.service.delete(element.idHipo).subscribe((result) => {
          this.search();
        });
      }
    });
    
  }

}